import React, { useState, useContext } from 'react';
import '../../styles/mobileNavbar.css';
import { Link } from 'react-router-dom';
import NavbarContext from '../../context/NavbarContext';
function MobileNavBar() {
  const { isOpen, setOpen } = useContext(NavbarContext);

  const toggleHamNavBars = () => {
    setOpen(!isOpen);
  };

  return (
    <>
      <div className='mobileNavBox'>
        <nav>
          <ul className='mobileUL'>
            <li className={'liStlye'}>
              <Link to='/' className='link' onClick={toggleHamNavBars}>
                Home
              </Link>
            </li>
            <li className={'liStlye'}>
              <a
                href='https://www.google.com/search?q=el+jarochito+mexican+food+truck&...#vhid=33:/g/11sk6r3sgp&vssid=menu-viewer-entrypoint'
                className='link'
                target='_blank'
                rel='noopener noreferrer'
              >
                Menu
              </a>
            </li>
            <li className={'liStlye'}>
              <Link to='/ordernow' className='link' onClick={toggleHamNavBars}>
                Order Now
              </Link>
            </li>
            <li className={'liStlye'}>
              <Link to='/location' onClick={toggleHamNavBars}>
                Location
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}

export default MobileNavBar;
